<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-box"></i></span>{{ 'AssignPicker.Header' | translate }}</h1>
  <p-card>
      <p-accordion (onOpen)="bookingAccordionTabOpen()" >
          <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
              <form [formGroup]="searchForm">
                <div class="p-fluid formgrid grid">

                  <div class="col-12 md:col-6 lg:col-3 mb-3">
                    <label>{{ 'AssignPicker.Search.Forwarder' | translate }}</label>
                    <p-multiSelect formControlName="bookingForwarders"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.bookingForwarders"
                                [options]="forwarderOptions"
                                [filter]="true"
                                filterBy="label" >
                            </p-multiSelect>
                  </div>

                  <div class="col-12 md:col-6 lg:col-3 mb-3">
                    <label>{{ 'AssignPicker.Search.BookingNum' | translate }}</label>
                    <p-chips formControlName="bookingNos" [(ngModel)]="searchParams.bookingNos" separator=","
                    (onAdd)="bookingNoChipsAdd($event)"></p-chips>
                  </div>

                  <div class="col-12 md:col-6 lg:col-3 mb-3">
                    <label>{{ 'AssignPicker.Search.DONum' | translate }}</label>
                    <p-chips formControlName="doNos" [(ngModel)]="searchParams.doNos" separator=","
                    (onAdd)="doNoChipsAdd($event)"></p-chips>
                  </div>

                  <div class="col-12 md:col-6 lg:col-3 mb-3">
                    <label>{{ 'AssignPicker.Search.CustomerCode' | translate }}</label>
                    <p-chips formControlName="consigneeKeys" [(ngModel)]="searchParams.consigneeKeys" separator=","
                    (onAdd)="consigneeKeyChipsAdd($event)"></p-chips>
                  </div>

                  <div class="col-12 md:col-6 lg:col-3 mb-3">
                    <div class="mb-1">{{ 'BookingSearch.Form.CarTrip' | translate}}</div>
                    <input pInputText formControlName="carTrip" type="text" [(ngModel)]="searchParams.carTrip" />
                  </div>

                  <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                    <laas-calendar
                        #AssignDate
                        [title]="'AssignPicker.Search.AssignDate'"
                        [enableMaxDateIsToday]="false"
                        [selectionMode]="'single'"
                        (onDateChange)="dateOnChange($event,'AssignDate')">
                    </laas-calendar>
                </div>

                <div class="col-12 md:col-6 lg:col-3 mb-3">
                  <div class="mb-1">{{ 'AssignPicker.Search.DepartureTime' | translate }}</div>
                  <input pInputText formControlName="carSeq" type="text" [(ngModel)]="searchParams.carSeq" maxlength="4" size="4"  />
                </div>
                <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                  <laas-calendar
                        #IssuanceDate
                        [title]="'AssignPicker.Search.IssuanceDate'"
                        [enableMaxDateIsToday]="false"
                        [selectionMode]="'single'"
                        (onDateChange)="dateOnChange($event,'IssuanceDate')">
                    </laas-calendar>
                </div>
                </div>
                <div class="grid">
                    <div class="col">
                        <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick('2')"></button>
                    </div>
                </div>
              </form>
          </p-accordionTab>
      </p-accordion>
      <div class="mt-2">

        <laas-data-table
          [expandable]="true"
          (rowExpanded)="searchDetailClick($event)"
          [dataKey]="'carTrip'"
          [tableKey]="preferenceKey"
          [value]="mainRows"
          [defaultColumns]="columns"
          [loading]="isLoading">
          <ng-template pTemplate="caption">
            <laas-permission-button permissionCode="BtnAssignPickTaskAssign" label="{{ 'AssignPicker.MainTable.Button.Assign' | translate }}" [class]="'ml-4'" (onClick)="assignBtnClick($event)"></laas-permission-button>
          </ng-template>



          <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'forwarderCodeAndName'"><div class="overflow-text">{{ rowData[col.field]   }}</div></ng-container>
                <ng-container *ngSwitchCase="'assignDate'"><div class="overflow-text">{{ rowData[col.field]   }}</div></ng-container>
                <ng-container *ngSwitchCase="'carSeq'"><div class="overflow-text">{{ rowData[col.field]   }}</div></ng-container>
                <ng-container *ngSwitchCase="'carTrip'"><div class="overflow-text">{{ rowData[col.field] }}</div></ng-container>
                <ng-container *ngSwitchCase="'carNoNote'"><div class="overflow-text">{{ rowData[col.field]   }}</div></ng-container>
                <ng-container *ngSwitchCase="'bookingNoCount'"><div class="overflow-text">{{ rowData[col.field]   }}</div></ng-container>
                <ng-container *ngSwitchCase="'expectedCnt'"><div class="overflow-text">{{ rowData[col.field] }}</div></ng-container>
                <ng-container *ngSwitchCase="'dropCnt'"><div class="overflow-text">{{ rowData[col.field] }}</div></ng-container>
                <ng-container *ngSwitchCase="'bepicked1'"><div class="overflow-text">{{ rowData[col.field] }}</div></ng-container>
                <ng-container *ngSwitchCase="'bepicked2'"><div class="overflow-text">{{ rowData[col.field] }}</div></ng-container>
                <ng-container *ngSwitchCase="'assignUser'"><div class="overflow-text">{{ rowData[col.field] }}</div></ng-container>
                <ng-container *ngSwitchCase="'createUser'"><div class="overflow-text">{{ rowData[col.field] }}</div></ng-container>

              </ng-container>
            </td>
          </ng-template>

          <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
            <laas-data-table #dt
              [dataKey]="'doNo'"
              [value]="rowData.doNos"
              [loading]="isLoading"
              [paginator]="false"
              [defaultColumns]="detailColumns"
              [style]="{ 'overflow-y': 'auto' }"
              [tableKey]="preferenceKey2"  >

              <ng-template pTemplate="header" let-columns >

                <tr>
                  <th *ngFor="let col of columns">
                    {{col.header}}
                  </th>
                </tr>

              </ng-template>

              <ng-template pTemplate="body" let-rowData  let-columns="columns" >

                <td *ngFor="let col of columns">

                  <div [ngSwitch]="col.field">
                    <ng-container *ngSwitchCase="'__check'">
                      <p-checkbox *ngIf="(rowData.unpicked > 0)" [(ngModel)]="rowData.checked" [binary]="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                    </ng-container>

                    <ng-container *ngSwitchCase="'createUser'">
                      <div (click)="getPickCount($event, rowData.createUser)" class="link overflow-text">{{rowData.createUser}}</div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'createDt'">
                      <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone }}</div>
                    </ng-container>


                    <ng-container *ngSwitchDefault>
                      <div class="overflow-text">
                        {{ rowData[col.field] | replaceNullWith:'-'}}
                      </div>
                    </ng-container>

                  </div>

                </td>
              </ng-template>

            </laas-data-table>
          </ng-template>

        </laas-data-table>

      </div>
  </p-card>
</div>
<p-dialog header="揀貨概況" [style]="{width: '20vw'}" [(visible)]="isShowPickCount" appendTo="body" [modal]="true" [draggable]="false" [resizable]="false" [dismissableMask]="true">
  已揀總箱數 : {{pickedCount}} <br> 未揀總箱數 : {{toBePickedCount}} <br> 空飛已揀總箱數 : {{dropBepicked}} <br> 空飛未揀總箱數 : {{dropUnpicked}}
</p-dialog>
<p-dialog p-dialog header="{{ 'AssignPicker.MainTable.Button.Assign' | translate }}" appendTo="body" [(visible)]="isShowAssignModal" [modal]="true" [draggable]="false" [resizable]="false" [dismissableMask]="true" (onHide)="modalHide($event)">
  <div class="p-fluid formgrid mt-2">
      <div class="field grid">
          <label class="col-4">揀貨人員</label>
          <div class="col-8">
              <input pInputText [(ngModel)]="assignShipping" />
          </div>
      </div>
  </div>
  <div class="grid mt-2">
      <div class="col text-center">
          <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}" (click)="modalConfirmBtnClick($event)"></button>
          <button pRipple pButton label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-2" (click)="modalCancelBtnClick($event)"></button>
      </div>
  </div>
</p-dialog>

<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
